const getters = {
  bizInfo: state => state.BizInfo,
};
export default getters;
